import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

/**
 * Search across all indexed resources using the global search endpoint.
 * @param {Object} [opts]
 * @param {String} [opts.search] - Search term
 * @param {String[]} [opts.resourceTypes] - Resource types to filter by
 * @param {String[]} [opts.tags] - Tag names to filter by
 * @param {Number} [opts.parentResourceId] - Parent resource ID (e.g. pollId for displays)
 * @param {Number} [opts.page=1] - Page number
 * @param {Number} [opts.limit=20] - Results per page
 * @returns {Promise<{results: Object[], total: Number, page: Number, limit: Number}>}
 */
export const search = async (opts = {}) => {
  const {
    search: searchTerm,
    resourceTypes = [],
    tags = [],
    parentResourceId,
    page = 1,
    limit = 20,
  } = opts;

  const query = { page, limit };

  if (searchTerm) {
    query.search = searchTerm;
  }

  if (resourceTypes.length) {
    query.resourceTypes = resourceTypes;
  }

  if (tags.length) {
    query.tags = tags;
  }

  if (parentResourceId) {
    query.parentResourceId = parentResourceId;
  }

  return fetch(getUrl('/search'), { query });
};

/**
 * Fetch tags matching the given filters via the search tags endpoint.
 * @param {Object} [opts]
 * @param {String} [opts.search] - Search term to filter tags by name
 * @param {String[]} [opts.resourceTypes] - Resource types to scope tags to
 * @returns {Promise<{tags: Array<{id: Number, tagName: String}>}>}
 */
export const getTags = async (opts = {}) => {
  const {
    search: searchTerm,
    resourceTypes = [],
  } = opts;

  const query = {};

  if (searchTerm) {
    query.search = searchTerm;
  }

  if (resourceTypes.length) {
    query.resourceTypes = resourceTypes.join(',');
  }

  return fetch(getUrl('/search/tags'), { query });
};
